/** 药店宝平台系统*/
import Bridge from './bridge_sdk'


export default {
    /**关闭当前H5页面回到APP首页*/
    backToHome(data) {
        data['name'] = 'UDbackToHome'
        return new Promise((resolve, reject) => {
            Bridge.callhandler( data['name'] , data,(data)=>{
                resolve(JSON.parse(data));
            })
        })

    },
    /**关闭当前H5页面*/
    finish(data) {
        data['name'] = 'UDfinish'
        return new Promise((resolve, reject) => {
            Bridge.callhandler( data['name'] , data,(data)=>{
                resolve(JSON.parse(data));
            })
        })

    },
    /**上传照片type：支持类型
     (1.拍照和从手机相册获取2.只调拍照3.只调从手机相册获取）
     安卓会直接在upImage中返回，苹果需要单独在mounted中注册getImage，在getImage中返回链接地址
     示例：*/
    upImage(data) {
        data['name'] = 'UDupImage'
        return new Promise((resolve, reject) => {
            Bridge.callhandler( data['name'] , data, (data) => {
                resolve(JSON.parse(data));
            })

        })

    },
    getImage() {
        return new Promise((resolve, reject) => {
            Bridge.registerhandler('UDgetImage', (data, responseCallback) => {
                resolve(JSON.parse(data))
            })

        })

    },
    //下载图片到本地
    downImage(data) {
        data['name'] = 'UDdownImage'
        return new Promise((resolve, reject) => {
            Bridge.callhandler( data['name'] , data, (data) => {
                resolve(JSON.parse(data));
            })

        })
    },
    /**打开地图显示位置*/
    toNavigate(data) {
        data['name'] = 'UDtoNavigate'
        return new Promise((resolve, reject) => {
            Bridge.callhandler( data['name'] , data, (data) => {
                resolve(JSON.parse(data))
            });

        })

    },

    /**拨打电话*/
    toTel(data) {
        data['name'] = 'UDtoTel'
        return new Promise((resolve, reject) => {
            Bridge.callhandler( data['name'] , data, (data) => {
                resolve(JSON.parse(data))
            });

        })

    },
    /**触发扫一扫*/
    setScavenging(data) {
        console.log('1234');
        data['name'] = 'UDsetScavenging'
        return new Promise((resolve, reject) => {
            Bridge.callhandler( data['name'] , data, (data) => {
                resolve(JSON.parse(data))
            });

        })

    },
    //扫一扫 返回值
    resolveSetScavenging() {
        return new Promise((resolve, reject) => {
            Bridge.registerhandler('UDresolveSetScavenging', (data, responseCallback) => {
                resolve(JSON.parse(data))
            })

        })

    },
    /**用户信息*/
    getUserInfo(data) {
        data['name'] = 'UDuserInfo'
        return new Promise((resolve, reject) => {
            Bridge.callhandler( data['name'] , data, (data) => {
                resolve(JSON.parse(data))
            });

        })

    },
    /**版本信息*/
    getVersion(data) {
        data['name'] = 'UDAppVersion'
        return new Promise((resolve, reject) => {
            Bridge.callhandler(data['name'], data, (data) => {
                resolve(JSON.parse(data))
            });

        })

    },

    /**404意见反馈*/
    toFeedBack(data) {
        data['name'] = 'UDtoFeedBack'
        return new Promise((resolve, reject) => {
            Bridge.callhandler( data['name'] , data, (data) => {
                resolve()
            });

        })

    },

    /**APP分享
     * shareLink:需要分享的链接地址
     * shareTitle:分享抬头名称
     * shareDescr:分享描述
     * shareImg:分享logo图片
     * shareType: 1是好友  2是朋友圈
     * shareBigImg: 1是0否  是否大图
     * */
    wxShare(data) {
        data['name'] = 'UDwxShare'
        return new Promise((resolve, reject) => {
            Bridge.callhandler( data['name'] , data, (data) => {
                resolve()
            });

        })

    },
    /**复制信息到剪贴板*/
    copy(data) {
        data['name'] = 'UDcopy'
        return new Promise((resolve, reject) => {
            Bridge.callhandler( data['name'] , data, (data) => {
                resolve(JSON.parse(data))
                // 处理返回数据
            })
        })

    },

  /**APP分享
     * shareLink:需要分享的链接地址
     * shareTitle:分享抬头名称
     * shareDescr:分享描述
     * shareImg:分享logo图片
     * shareType: 1是好友  2是朋友圈
     * shareBigImg: 1是0否  是否大图
     * */
    serviceShare(data) {
        data['name'] = 'UDserviceShare'
        return new Promise((resolve, reject) => {
            Bridge.callhandler( data['name'] , data, (data) => {
                resolve()
            });

        })

    },
    /**是否隐藏分享按钮*/  //data:{ type: 1 } 隐藏；  type:0 显示
    setShareHidden(data) {
        data['name'] = 'UDsetShareHidden'

        console.log('dataSetShare',data)
        return new Promise((resolve, reject) => {
            Bridge.callhandler( data['name'] , data,(data)=>{
                resolve(JSON.parse(data));
            })
        })

    },
}
